import React, { Component } from 'react';

import Form from './Form';
import Result from './Result';

class Router extends Component {
  constructor(props) {
    super(props);

    // Intentionally ignore prop updates: this component will only ever render
    // a single view during it's lifecycle
    this.state = {
      currentView: this.props.currentView
    };
  }

  render() {
    switch (this.state.currentView) {
      case 'result':
        return <Result {...this.props} />;
      case 'form':
        return <Form {...this.props} />;
      default:
        return <Form {...this.props} />;
    }
  }
}

export default Router;
